module.exports = __webpack_public_path__ + "static/media/SC-PRO.22b353a9.pdf";